import { useState, useEffect } from "react";
import { builderClient } from "@/utils/builder";
import { BuilderComponent } from "@builder.io/react";
import { useRouter } from "next/compat/router";
import { removeTargetAttr } from "@/helpers/generalHelper";

const SuperbrandPLP = () => {
  const [builderContentJson, setBuilderContentJson] = useState(null);

  const router = useRouter();

  useEffect(() => {
    builderClient.setUserAttributes({
      userAttributes: {
        urlPath: router.asPath.split("?")[0],
      },
    })

    builderClient
      .get("superbrand")
      .promise()
      .then(setBuilderContentJson);
    if (builderContentJson) {
      removeTargetAttr
    }
  }, []);

  return <BuilderComponent model="superbrand" content={builderContentJson} />;
};

export default SuperbrandPLP;
